<div class="d-flex justify-content-between align-items-center mb-3">
    <h3 class="mb-0">Quoting</h3>
</div>

<div class="alert alert-info py-2">
    Capture vendor quotes here and convert an accepted quote into a Purchase Order. Outbound RFQs and vendor
    quote intake are planned for a later phase.
</div>

<div class="purchasing-table-panel">
    <table class="table table-sm table-hover mb-0">
            <thead>
                <tr>
                    <th>Quote #</th>
                    <th>Vendor</th>
                    <th>Job</th>
                    <th>Quote Date</th>
                    <th>Status</th>
                    <th class="text-end">Total</th>
                </tr>
            </thead>
            <tbody>
                @for (quote of quotes; track quote.id) {
                    <tr>
                        <td>{{ quote.quoteNumber }}</td>
                        <td>{{ quote.vendorName }}</td>
                        <td>{{ quote.job }}</td>
                        <td>{{ quote.quoteDate | date: 'shortDate' }}</td>
                        <td>{{ quote.status }}</td>
                        <td class="text-end">{{ quote.total | currency }}</td>
                    </tr>
                }
                @if (quotes.length === 0) {
                    <tr>
                        <td colspan="6" class="text-center text-muted py-3">No quotes yet.</td>
                    </tr>
                }
            </tbody>
        </table>
</div>
